module.exports = __webpack_public_path__ + "img/default-icon.71ce3cc0.png";